// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BXfluY0{display:flex;flex-direction:column;flex-wrap:wrap}.DUdsr7R:not(:last-child),.BXfluY0 .DUdsr7R:not(:last-child){margin-bottom:1em}.wMohD1P,.BXfluY0 .wMohD1P{border-radius:1.88em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BXfluY0`,
	"skeleton": `DUdsr7R`,
	"skeletonButton": `wMohD1P`
};
export default ___CSS_LOADER_EXPORT___;
